(() => {
  const countryDialCodes = [["AC","247",""],["AD","376",""],["AE","971","0"],["AF","93","0"],["AG","1","1"],["AI","1","1"],["AL","355","0"],["AM","374","0"],["AO","244",""],["AR","54","0"],["AS","1","1"],["AT","43","0"],["AU","61","0"],["AW","297",""],["AX","358","0"],["AZ","994","0"],["BA","387","0"],["BB","1","1"],["BD","880","0"],["BE","32","0"],["BF","226",""],["BG","359","0"],["BH","973",""],["BI","257",""],["BJ","229",""],["BL","590","0"],["BM","1","1"],["BN","673",""],["BO","591","0"],["BQ","599",""],["BR","55","0"],["BS","1","1"],["BT","975",""],["BW","267",""],["BY","375","8"],["BZ","501",""],["CA","1","1"],["CC","61","0"],["CD","243","0"],["CF","236",""],["CG","242",""],["CH","41","0"],["CI","225",""],["CK","682",""],["CL","56",""],["CM","237",""],["CN","86","0"],["CO","57","0"],["CR","506",""],["CU","53","0"],["CV","238",""],["CW","599",""],["CX","61","0"],["CY","357",""],["CZ","420",""],["DE","49","0"],["DJ","253",""],["DK","45",""],["DM","1","1"],["DO","1","1"],["DZ","213","0"],["EC","593","0"],["EE","372",""],["EG","20","0"],["EH","212","0"],["ER","291","0"],["ES","34",""],["ET","251","0"],["FI","358","0"],["FJ","679",""],["FK","500",""],["FM","691",""],["FO","298",""],["FR","33","0"],["GA","241",""],["GB","44","0"],["GD","1","1"],["GE","995","0"],["GF","594","0"],["GG","44","0"],["GH","233","0"],["GI","350",""],["GL","299",""],["GM","220",""],["GN","224",""],["GP","590","0"],["GQ","240",""],["GR","30",""],["GT","502",""],["GU","1","1"],["GW","245",""],["GY","592",""],["HK","852",""],["HN","504",""],["HR","385","0"],["HT","509",""],["HU","36","06"],["ID","62","0"],["IE","353","0"],["IL","972","0"],["IM","44","0"],["IN","91","0"],["IO","246",""],["IQ","964","0"],["IR","98","0"],["IS","354",""],["IT","39",""],["JE","44","0"],["JM","1","1"],["JO","962","0"],["JP","81","0"],["KE","254","0"],["KG","996","0"],["KH","855","0"],["KI","686","0"],["KM","269",""],["KN","1","1"],["KP","850","0"],["KR","82","0"],["KW","965",""],["KY","1","1"],["KZ","7","8"],["LA","856","0"],["LB","961","0"],["LC","1","1"],["LI","423","0"],["LK","94","0"],["LR","231","0"],["LS","266",""],["LT","370","0"],["LU","352",""],["LV","371",""],["LY","218","0"],["MA","212","0"],["MC","377","0"],["MD","373","0"],["ME","382","0"],["MF","590","0"],["MG","261","0"],["MH","692","1"],["MK","389","0"],["ML","223",""],["MM","95","0"],["MN","976","0"],["MO","853",""],["MP","1","1"],["MQ","596","0"],["MR","222",""],["MS","1","1"],["MT","356",""],["MU","230",""],["MV","960",""],["MW","265","0"],["MX","52",""],["MY","60","0"],["MZ","258",""],["NA","264","0"],["NC","687",""],["NE","227",""],["NF","672",""],["NG","234","0"],["NI","505",""],["NL","31","0"],["NO","47",""],["NP","977","0"],["NR","674",""],["NU","683",""],["NZ","64","0"],["OM","968",""],["PA","507",""],["PE","51","0"],["PF","689",""],["PG","675",""],["PH","63","0"],["PK","92","0"],["PL","48",""],["PM","508","0"],["PR","1","1"],["PS","970","0"],["PT","351",""],["PW","680",""],["PY","595","0"],["QA","974",""],["RE","262","0"],["RO","40","0"],["RS","381","0"],["RU","7","8"],["RW","250","0"],["SA","966","0"],["SB","677",""],["SC","248",""],["SD","249","0"],["SE","46","0"],["SG","65",""],["SH","290",""],["SI","386","0"],["SJ","47",""],["SK","421","0"],["SL","232","0"],["SM","378",""],["SN","221",""],["SO","252","0"],["SR","597",""],["SS","211","0"],["ST","239",""],["SV","503",""],["SX","1","1"],["SY","963","0"],["SZ","268",""],["TA","290",""],["TC","1","1"],["TD","235",""],["TG","228",""],["TH","66","0"],["TJ","992",""],["TK","690",""],["TL","670",""],["TM","993","8"],["TN","216",""],["TO","676",""],["TR","90","0"],["TT","1","1"],["TV","688",""],["TW","886","0"],["TZ","255","0"],["UA","380","0"],["UG","256","0"],["US","1","1"],["UY","598","0"],["UZ","998",""],["VA","39",""],["VC","1","1"],["VE","58","0"],["VG","1","1"],["VI","1","1"],["VN","84","0"],["VU","678",""],["WF","681",""],["WS","685",""],["XK","383","0"],["YE","967","0"],["YT","262","0"],["ZA","27","0"],["ZM","260","0"],["ZW","263","0"]];
  if (customElements.get('neli-welcome-popup')) return;
  customElements.define('neli-welcome-popup', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.dialog = this.querySelector('dialog');
      this.form = this.querySelector('form');
      this.backdrop = this.querySelector('[data-backdrop]');
      if (!this.dialog || !this.form) return;
      this.key = 'neli-welcome-v1';
      this.pendingKey = this.key + '-pending';
      this.scrollKey = this.key + '-first-scroll';
      this.cookieKey = 'neli_newsletter_subscribed';
      this.designMode = Boolean(window.Shopify?.designMode);
      this.previewMode = new URLSearchParams(location.search).has('neli_popup_preview');
      this.visitKey = 'neli-welcome-visit-v2' + (this.designMode || this.previewMode ? '-preview' : '');
      this.visitCookieKey = 'neli_welcome_visit_v2' + (this.designMode || this.previewMode ? '_preview' : '');
      this.visitTimeout = 30 * 60 * 1000;
      this.refreshVisit();
      this.setupPhone(signal);
      this.submitButton = this.querySelector('[data-submit]');
      this.submitLabel = this.submitButton.textContent;
      this.querySelector('[data-next]').addEventListener('click', () => this.setStep(2), {signal});
      this.querySelector('[data-back]').addEventListener('click', () => this.setStep(1), {signal});
      this.querySelector('[data-copy]').addEventListener('click', () => this.copyCode(), {signal});
      this.querySelectorAll('[data-close]').forEach(button => button.addEventListener('click', () => this.close(), {signal}));
      this.backdrop.addEventListener('click', () => this.close(), {signal});
      document.addEventListener('keydown', event => this.handleKeys(event), {signal});
      this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.close(); }, {signal});
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const r = this.dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.close();
      }, {signal});
      this.dialog.addEventListener('close', () => this.restorePage(), {signal});
      this.form.addEventListener('submit', event => {
        this.syncPhone();
        if (!this.form.checkValidity()) { event.preventDefault(); this.form.reportValidity(); return; }
        if (this.designMode) { event.preventDefault(); this.setStep(3); return; }
        this.writeStorage('session', this.pendingKey, String(Date.now()));
        this.submitButton.textContent = this.dataset.submitting;
        this.submitButton.setAttribute('aria-busy', 'true');
        this.submitTimer = setTimeout(() => this.resetSubmit(), 12000);
      }, {signal});
      window.addEventListener('scroll', event => this.trackActivity(event), {passive: true, signal});
      document.addEventListener('pointerdown', event => this.trackActivity(event), {passive: true, signal});
      document.addEventListener('keydown', event => this.trackActivity(event), {signal});
      document.addEventListener('visibilitychange', event => this.trackActivity(event), {signal});
      window.addEventListener('pageshow', event => {
        this.resetSubmit();
        if (event.persisted && this.dialog.open && this.step !== 3) this.close(false);
        this.trackActivity(event);
        if (this.isDismissed()) this.close(false);
      }, {signal});
      window.addEventListener('storage', event => {
        if ((event.key === this.key || event.key === this.visitKey) && this.isSuppressed()) {
          clearTimeout(this.timer);
          if (this.dialog.open && (this.isDismissed() || (event.key === this.key && !this.designMode && !this.previewMode && this.step !== 3))) this.close(false);
        }
      }, {signal});
      document.addEventListener('shopify:section:select', event => {
        if (event.detail?.sectionId === this.dataset.sectionId) this.open(Number(this.dataset.previewStep) || 1);
      }, {signal});
      document.addEventListener('shopify:section:deselect', event => {
        if (event.detail?.sectionId === this.dataset.sectionId) this.close(false);
      }, {signal});
      const pending = Number(this.readStorage('session', this.pendingKey));
      const recentSubmission = pending && Date.now() - pending < 30 * 60 * 1000;
      const result = this.querySelector('[data-form-result]');
      if (this.dataset.subscribed === 'true' || result.dataset.success === 'true') this.rememberSubscribed();
      if (recentSubmission && result.dataset.success === 'true' && !this.isDismissed()) {
        this.writeStorage('session', this.pendingKey, '');
        this.open(3);
      } else if (recentSubmission && result.dataset.errors === 'true' && !this.isDismissed()) {
        this.open(2);
      } else if (this.designMode) {
        if (!this.readVisit()?.shown) this.open(Number(this.dataset.previewStep) || 1);
      } else if (this.previewMode) {
        if (!this.readVisit()?.shown) this.open(1);
      } else if (this.canAutoOpen()) {
        this.waitForScroll(signal);
      }
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      clearTimeout(this.submitTimer);
      if (this.scrollHandler) window.removeEventListener('scroll', this.scrollHandler);
      this.controller?.abort();
      this.restorePage();
      this.controller = null;
    }
    readStorage(storage, key) { try { return window[storage + 'Storage'].getItem(key); } catch { return null; } }
    writeStorage(storage, key, value) { try { window[storage + 'Storage'].setItem(key, value); } catch {} }
    readCookie(key) {
      try {
        const value = document.cookie.split(';').map(value => value.trim()).find(value => value.startsWith(key + '='));
        return value ? decodeURIComponent(value.slice(key.length + 1)) : null;
      } catch { return null; }
    }
    hasCookie(key) { return this.readCookie(key) === '1'; }
    readVisit() {
      const now = Date.now();
      const records = [this.visit];
      for (const value of [this.readStorage('local', this.visitKey), this.readStorage('session', this.visitKey), this.readCookie(this.visitCookieKey)]) {
        try { records.push(JSON.parse(value)); } catch {}
      }
      const active = records.filter(value => value && typeof value.id === 'string' && Number.isFinite(value.lastActivity) && value.lastActivity <= now && now - value.lastActivity < this.visitTimeout);
      active.sort((a, b) => b.lastActivity - a.lastActivity);
      const latest = active[0];
      if (!latest) return null;
      const sameVisit = active.filter(value => value.id === latest.id);
      return {id: latest.id, lastActivity: latest.lastActivity, shown: sameVisit.some(value => value.shown === true), dismissed: sameVisit.some(value => value.dismissed === true)};
    }
    writeVisit(visit) {
      this.visit = visit;
      const value = JSON.stringify(visit);
      this.writeStorage('local', this.visitKey, value);
      this.writeStorage('session', this.visitKey, value);
      try { document.cookie = this.visitCookieKey + '=' + encodeURIComponent(value) + '; Max-Age=1800; Path=/; SameSite=Lax; Secure'; } catch {}
    }
    refreshVisit() {
      const now = Date.now();
      const previousId = this.visit?.id;
      const visit = this.readVisit() || {id: String(now), shown: this.dialog.open, dismissed: false};
      const changed = visit.id !== previousId;
      this.scrollKey = this.key + '-first-scroll-' + visit.id;
      this.writeVisit({...visit, lastActivity: now});
      this.lastActivityCheck = now;
      return changed;
    }
    trackActivity(event) {
      if (document.hidden || Date.now() - this.lastActivityCheck < 5000) return;
      if (this.refreshVisit() && !this.dialog.open && this.canAutoOpen()) this.waitForScroll(this.controller.signal, event.type === 'scroll');
    }
    canAutoOpen() {
      return !this.designMode && !this.previewMode && this.dataset.enabled === 'true' && !this.isSuppressed() && !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:challenge|account|checkout)(?:\/|$)/i.test(location.pathname);
    }
    isDismissed() { return Boolean(this.readVisit()?.dismissed); }
    rememberDismissed() {
      this.refreshVisit();
      this.writeVisit({...this.visit, shown: true, dismissed: true});
      this.writeStorage('session', this.pendingKey, '');
      this.writeStorage('session', this.scrollKey, '');
    }
    rememberSubscribed() {
      this.writeStorage('local', this.key, JSON.stringify({subscribed: true}));
      try { document.cookie = this.cookieKey + '=1; Max-Age=31536000; Path=/; SameSite=Lax; Secure'; } catch {}
      clearTimeout(this.timer);
    }
    isSuppressed() {
      if (this.dataset.subscribed === 'true' || this.readVisit()?.shown || this.hasCookie(this.cookieKey)) return true;
      try { return Boolean(JSON.parse(this.readStorage('local', this.key))?.subscribed); } catch { return false; }
    }
    waitForScroll(signal, scrolled = false) {
      clearTimeout(this.timer);
      if (this.scrollHandler) window.removeEventListener('scroll', this.scrollHandler);
      if (scrolled) this.writeStorage('session', this.scrollKey, String(Date.now()));
      const started = Number(this.readStorage('session', this.scrollKey));
      const delay = (Number(this.dataset.delay) || 30) * 1000;
      if (started > 0 && started <= Date.now()) {
        this.timer = setTimeout(() => this.autoOpen(), Math.max(0, delay - (Date.now() - started)));
        return;
      }
      const initialY = window.scrollY;
      this.scrollHandler = () => {
        if (Math.abs(window.scrollY - initialY) < 24) return;
        window.removeEventListener('scroll', this.scrollHandler);
        if (this.isSuppressed()) return;
        this.writeStorage('session', this.scrollKey, String(Date.now()));
        this.timer = setTimeout(() => this.autoOpen(), delay);
      };
      window.addEventListener('scroll', this.scrollHandler, {passive: true, signal});
    }
    autoOpen() {
      if (!this.readVisit() || this.isSuppressed()) return;
      const anotherDialog = [...document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"]')].some(el => el !== this.dialog && el.getBoundingClientRect().width > 0 && getComputedStyle(el).visibility !== 'hidden' && getComputedStyle(el).opacity !== '0');
      if (document.hidden || anotherDialog) {
        this.timer = setTimeout(() => this.autoOpen(), 2000);
        return;
      }
      if (!this.isSuppressed()) this.open(1);
    }
    setStep(step) {
      this.step = step;
      this.dialog.dataset.currentStep = String(step);
      this.querySelectorAll('[data-step]').forEach(panel => { panel.hidden = Number(panel.dataset.step) !== step; });
      this.querySelectorAll('[data-dot]').forEach(dot => dot.toggleAttribute('data-active', Number(dot.dataset.dot) <= step));
      const heading = this.querySelector(`[data-step="${step}"] h2`);
      this.dialog.setAttribute('aria-labelledby', heading.id);
      this.dialog.scrollTop = 0;
      if (this.dialog.open) heading.focus({preventScroll: true});
    }
    open(step = 1) {
      this.refreshVisit();
      this.writeVisit({...this.visit, shown: true});
      this.setStep(step);
      if (!this.dialog.open) {
        this.previousFocus = document.activeElement;
        this.previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        this.backdrop.hidden = false;
        this.dialog.show();
      }
      this.querySelector(`[data-step="${step}"] h2`).focus({preventScroll: true});
    }
    close(remember = true) {
      clearTimeout(this.timer);
      if (this.scrollHandler) window.removeEventListener('scroll', this.scrollHandler);
      if (remember) this.rememberDismissed();
      this.dialog.close();
    }
    handleKeys(event) {
      if (!this.dialog.open) return;
      const securityFrame = [...document.querySelectorAll('iframe[src*="hcaptcha"][src*="frame=challenge"]')].some(frame => frame.getBoundingClientRect().width > 0 && getComputedStyle(frame).visibility !== 'hidden');
      if (securityFrame) return;
      if (event.key === 'Escape') { event.preventDefault(); this.close(); return; }
      if (event.key !== 'Tab') return;
      const focusable = [...this.dialog.querySelectorAll('button, a[href], input:not([type=hidden]), select')].filter(el => !el.disabled && el.getClientRects().length);
      const first = focusable[0], last = focusable.at(-1);
      if (event.shiftKey && (document.activeElement === first || !this.dialog.contains(document.activeElement))) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && (document.activeElement === last || !this.dialog.contains(document.activeElement))) { event.preventDefault(); first?.focus(); }
    }
    restorePage() {
      if (this.backdrop) this.backdrop.hidden = true;
      if (this.previousOverflow !== undefined) {
        document.documentElement.style.overflow = this.previousOverflow;
        this.previousOverflow = undefined;
        this.previousFocus?.focus?.({preventScroll: true});
      }
    }
    resetSubmit() {
      clearTimeout(this.submitTimer);
      if (this.submitButton) { this.submitButton.removeAttribute('aria-busy'); this.submitButton.textContent = this.submitLabel; }
    }
    setupPhone(signal) {
      this.phoneCountry = this.querySelector('[data-phone-country-select]');
      this.phoneNumber = this.querySelector('[data-phone-number]');
      this.phoneFull = this.querySelector('[data-phone-full]');
      if (!this.phoneCountry || !this.phoneNumber || !this.phoneFull) return;
      let names;
      try { names = new Intl.DisplayNames([this.dataset.locale || 'fr'], {type: 'region'}); } catch {}
      const countries = countryDialCodes.map(([iso, code]) => ({iso, code, name: names?.of(iso) || iso}));
      countries.sort((a, b) => a.name.localeCompare(b.name, this.dataset.locale || 'fr'));
      this.phoneCountry.replaceChildren(...countries.map(country => {
        const option = document.createElement('option');
        option.value = country.iso;
        option.textContent = country.name + ' (+' + country.code + ')';
        option.selected = country.iso === this.dataset.phoneCountry;
        return option;
      }));
      this.phoneCountry.addEventListener('change', () => this.syncPhone(), {signal});
      this.phoneNumber.addEventListener('input', () => this.syncPhone(), {signal});
      this.syncPhone();
    }
    formatPhone(raw, country) {
      const value = raw.trim();
      if (!value) return '';
      if (!/^\+?[\d\s().-]+$/.test(value)) return null;
      const [, code, prefix] = countryDialCodes.find(row => row[0] === country) || [];
      if (!code) return null;
      let digits = value.replace(/\D/g, '');
      if (value.startsWith('+')) return /^[1-9]\d{4,14}$/.test(digits) ? '+' + digits : null;
      if (value.startsWith('00')) return /^[1-9]\d{4,14}$/.test(digits.slice(2)) ? '+' + digits.slice(2) : null;
      if (prefix && /^\d+$/.test(prefix) && digits.startsWith(prefix) && digits.length > 8) digits = digits.slice(prefix.length);
      const full = code + digits;
      return digits.length >= 4 && /^[1-9]\d{4,14}$/.test(full) ? '+' + full : null;
    }
    syncPhone() {
      if (!this.phoneNumber) return;
      const country = this.phoneCountry.value;
      const entry = countryDialCodes.find(row => row[0] === country);
      const label = this.querySelector('[data-phone-country-label]');
      if (label && entry) {
        const flag = String.fromCodePoint(...[...country].map(letter => 127397 + letter.charCodeAt(0)));
        label.textContent = flag + ' +' + entry[1];
        this.phoneCountry.title = this.phoneCountry.selectedOptions[0].textContent;
      }
      const number = this.formatPhone(this.phoneNumber.value, this.phoneCountry.value);
      this.phoneFull.value = number || '';
      this.phoneFull.disabled = !number;
      this.phoneNumber.setCustomValidity(number === null ? this.dataset.phoneInvalid : '');
    }
    async copyCode() {
      const code = this.querySelector('[data-copy]').dataset.code;
      const status = this.querySelector('.neli-welcome__copy-status');
      try {
        await navigator.clipboard.writeText(code);
        status.textContent = this.dataset.copied;
      } catch {
        const range = document.createRange();
        range.selectNodeContents(this.querySelector('[data-code-text]'));
        const selection = window.getSelection();
        selection.removeAllRanges(); selection.addRange(range);
        status.textContent = this.dataset.copyFailed;
      }
    }
  });
})();
